@if (selectedSize() === visualsDashboardWidgetSizingEnum.SMALL) {
    <div class="row-container small">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="contentScoreSegments()"
            [centerLabel]="contentScoreCenterLabel()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        />
    </div>
} @else if (selectedSize() === visualsDashboardWidgetSizingEnum.MEDIUM_ROW) {
    <div class="row-container">
        <app-ice-visuals-dashboard-pie-chart
            [segments]="contentScoreSegments()"
            [centerLabel]="contentScoreCenterLabel()"
            [loading]="dataService.loading()"
            [variant]="pieChartVariantEnum.SMALL"
        />
        <app-ice-visuals-dashboard-horizontal-bar-chart
            [bars]="contentScoreBars()"
            [loading]="dataService.loading()"
            [scoreLabel]="'dashboard.visuals.widgets.contentScoreSummary.barChart.columns.yourScore'"
            [targetLabel]="'dashboard.visuals.widgets.contentScoreSummary.barChart.columns.iceAvg'"
        ></app-ice-visuals-dashboard-horizontal-bar-chart>
    </div>
}
